import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Icon } from '../../Atoms';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollToTop',
  setup(__props) {

const scroll = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "back-to-top",
    onClick: _cache[0] || (_cache[0] = () => scroll())
  }, [
    _createTextVNode(_toDisplayString(_ctx.$t('Back to top')) + " ", 1),
    _createVNode(_unref(Icon), { "icon-name": "arrowUp" })
  ]))
}
}

})